import styled from '@emotion/styled'

const InnerContainer = styled.div`
  width: calc(100% - 24px);
  height: calc(100% - 24px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: auto;
`

export { InnerContainer }
